"use client";
import React from "react";

import { Box } from "../../foundations";

interface AccordionProps {
  multiple?: boolean;
  children: React.ReactElement | React.ReactElement[];
}
interface AccordionContextProps {
  toggleItem: (itemId: string) => void;
  getIsExpanded: (itemId: string) => boolean;
  multiple: boolean;
}
export const AccordionContext = React.createContext<AccordionContextProps>({
  toggleItem: () => {},
  getIsExpanded: () => false,
  multiple: false
});

export const Accordion: React.FC<AccordionProps> = (props: AccordionProps) => {
  const { children, multiple = false } = props;
  const [expandedItems, setExpandedItems] = React.useState<Set<string>>(
    new Set<string>()
  );

  const getIsExpanded = (itemId: string) => expandedItems.has(itemId);

  const toggleItem = (itemId: string) => {
    let nextExpandedItems = new Set(expandedItems);
    if (nextExpandedItems.has(itemId)) {
      nextExpandedItems.delete(itemId);
    } else if (multiple) {
      nextExpandedItems.add(itemId);
    } else {
      nextExpandedItems = new Set([itemId]);
    }
    setExpandedItems(nextExpandedItems);
  };

  const context: AccordionContextProps = {
    toggleItem: toggleItem,
    getIsExpanded: getIsExpanded,
    multiple: multiple || false
  };

  return (
    <Box>
      <AccordionContext.Provider value={context}>
        {children}
      </AccordionContext.Provider>
    </Box>
  );
};
